import React from "react";

const PrivacyRetention = () => {
  return (
    <div className="privacy-retention">
      <h2>제2조(개인정보의 처리 및 보유 기간)</h2>

      <p>
        ① <strong>성신한방병원</strong>은(는) 법령에 따른 개인정보 보유·이용기간
        또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간
        내에서 개인정보를 처리·보유합니다.
      </p>

      <p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>

      <ul>
        <li>
          <strong>1. 홈페이지 회원가입 및 관리:</strong> 홈페이지 회원가입 및
          관리와 관련한 개인정보는 수집·이용에 관한 동의일로부터{" "}
          <strong>준영구</strong>까지 보유·이용됩니다.
          <ul>
            <li>
              <strong>보유근거:</strong> 회원가입일로부터 서비스를 제공하는 기간
              동안에 한하여 이용자의 개인정보를 보유 및 이용
            </li>
            <li>
              <strong>관련법령:</strong>
              <ul>
                <li>1) 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년</li>
                <li>2) 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
                <li>3) 대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
                <li>4) 계약 또는 청약철회 등에 관한 기록: 5년</li>
                <li>5) 표시/광고에 관한 기록: 6개월</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default PrivacyRetention;
